import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ITeamMultiplePlayerDTO,
  ITeamPlayerDTO,
} from "../../../../../../../api-services/football/admin/manage-football-team-service";
import { StatusEnum } from "../../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../../commons";

export interface IManageSubTeamPlayerAddEditState {
  manageSubTeamMultiplePlayersAddStatus: StatusEnum;
  manageSubTeamPlayerEditStatus: StatusEnum;
}

export interface IManageSubTeamPlayerEditOption {
  teamId: number;
  subTeamId: number;
  playerId: number;
  playerInfo: ITeamPlayerDTO;
}
export interface IManageSubTeamMultiplePlayersAddOption {
  teamId: number;
  subTeamId: number;
  playersInfo: ITeamMultiplePlayerDTO[];
}

const initialState: IManageSubTeamPlayerAddEditState = {
  manageSubTeamMultiplePlayersAddStatus: StatusEnum.Idle,
  manageSubTeamPlayerEditStatus: StatusEnum.Idle,
};

export const subTeamMultiplePlayersAdd = createAsyncThunk(
  "manage/subTeamMultiplePlayersAdd",
  async (options: IManageSubTeamMultiplePlayersAddOption, thunkAPI) => {
    try {
      const manageSubTeamMultiplePlayersAdd = await manageFootballTeamService.addSubTeamMultiplePlayers(
        options.teamId,
        options.subTeamId,
        options.playersInfo
      );
      return manageSubTeamMultiplePlayersAdd;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const subTeamPlayerEdit = createAsyncThunk(
  "manage/subTeamPlayerEdit",
  async (options: IManageSubTeamPlayerEditOption, thunkAPI) => {
    try {
      const manageSubTeamPlayerEdit = await manageFootballTeamService.editSubTeamPlayer(
        options.teamId,
        options.subTeamId,
        options.playerId,
        options.playerInfo
      );
      return manageSubTeamPlayerEdit;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageSubTeamPlayerAddEditSlice = createSlice({
  name: "manageSubTeamPlayerAddEditSlice",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(subTeamMultiplePlayersAdd.pending, (state) => {
        state.manageSubTeamMultiplePlayersAddStatus = StatusEnum.Loading;
      })
      .addCase(subTeamMultiplePlayersAdd.fulfilled, (state) => {
        state.manageSubTeamMultiplePlayersAddStatus = StatusEnum.Succeeded;
      })
      .addCase(subTeamMultiplePlayersAdd.rejected, (state) => {
        state.manageSubTeamMultiplePlayersAddStatus = StatusEnum.Failed;
      })
      .addCase(subTeamPlayerEdit.pending, (state) => {
        state.manageSubTeamPlayerEditStatus = StatusEnum.Loading;
      })
      .addCase(subTeamPlayerEdit.fulfilled, (state) => {
        state.manageSubTeamPlayerEditStatus = StatusEnum.Succeeded;
      })
      .addCase(subTeamPlayerEdit.rejected, (state) => {
        state.manageSubTeamPlayerEditStatus = StatusEnum.Failed;
      });
  },
});

export default manageSubTeamPlayerAddEditSlice.reducer;
